<template>
	<dr-wrapper :model="model" v-on="wrapOn">
		<dr-menu-horizontal @onMenuItemClick="onMenuItemClick" v-if="model.Orientation == 'horizontal'" :model="navigation.Menu"/>

		<dr-menu-vertical @onMenuItemClick="onMenuItemClick" v-else :model="navigation.Menu"/>
	</dr-wrapper>
</template>

<script>
import mixin from '../../mixins/base-mixin'
import widgetsWrapperMixin from '../../mixins/widgets-wrapper-mixin'
import drMenuVertical from './dr-menu-vertical.vue'
import drMenuHorizontal from './dr-menu-horizontal.vue'

export default {
  components: {
    'dr-menu-vertical': drMenuVertical,
    'dr-menu-horizontal': drMenuHorizontal
  },
  data: () => ({
    value: false
  }),
  mixins: [mixin, widgetsWrapperMixin],
  computed: {
    navigation() {
      return (this.model.Navigation || this.$store.state.appModels.model.Navigation) || { Menu: [{$ID: 1, Caption: 'test1', Icon: 'mdi-school'}, {$ID: 2, Caption: 'test2', Icon: 'mdi-pencil', Items: [{$ID: 4, Caption: 'test21', Icon: 'mdi-pencil'}]}, {$ID: 3,Caption: 'test3', Icon: 'mdi-pencil'}]}
    }
  },
  methods: {
    onMenuItemClick(item) {
      if (item.Action?.$Type == 'OpenPage') {
        this.$router.push('/' + item.Action.Page)
      }
    }
  }
}
</script>

<style>
</style>
